/**
 * EarthTexture source: http://www.shadedrelief.com/natural3/pages/textures.html
 * EarthSpecular and CloudTexture source: https://blog.mastermaps.com/2013/09/creating-webgl-earth-with-threejs.html
 * @author Damian Browne
 */
import { Mesh, SphereGeometry, MeshPhongMaterial, TextureLoader, Color, Group } from 'three'
import EarthTexture from '../textures/2_no_clouds_4k.jpg'
import EarthSpecular from '../textures/water_4k.png'
import CloudTexture from '../textures/fair_clouds_4k.png'

class Earth {
  constructor() {
    const loader = new TextureLoader()
    const texture = loader.load(EarthTexture)
    const cloud_text = loader.load(CloudTexture)
    const sm = loader.load(EarthSpecular)
    const earth_geo = new SphereGeometry(1, 8, 8)
    const earth_mat = new MeshPhongMaterial({ map: texture, specularMap: sm, specular: new Color('grey') })
    const cloud_geo = new SphereGeometry(1.01, 12, 12)
    const cloud_mat = new MeshPhongMaterial({ map: cloud_text, transparent: true })
    const earth = new Mesh(earth_geo, earth_mat)
    const cloud = new Mesh(cloud_geo, cloud_mat)

    this.group = new Group()
    this.group.add(earth, cloud)
    this.type = 'planet'
  }

  move(position) {
    this.group.position.x -= 0.08
    this.group.rotation.y += 0.001
  }
}

export default Earth
